import { routes } from '@app/router/routes'
import type { Component } from 'vue'
import type { PiIconName } from '@uiKit/elements/PiIcon.vue'
import { BusinessCenterIcon, HomeIcon, LocalMallIcon, VillaIcon } from '@uiKit/icons'

export interface AppNavItem {
  label: string
  to: string
  icon: PiIconName
  /** SVG glyph drawn instead of `icon` — the primary sections reuse investor-app's tab-bar glyphs. */
  svg?: Component
}

// Desktop rail order from the "Side Menu - NEW" Figma frame (32590:74310); glyphs match
// investor-app's bottom tab bar. Wallet is intentionally not a primary item — it stays in
// the profile menu.
export const APP_PRIMARY_NAV: AppNavItem[] = [
  { label: 'Dashboard', to: routes.DASHBOARD, icon: 'th-large', svg: HomeIcon },
  { label: 'Properties', to: routes.PROPERTIES, icon: 'building', svg: VillaIcon },
  { label: 'Marketplace', to: routes.MARKETPLACE, icon: 'shopping-bag', svg: LocalMallIcon },
  { label: 'Portfolio', to: routes.PORTFOLIO, icon: 'briefcase', svg: BusinessCenterIcon },
]

// Guests have no wallet and no holdings — every nav surface (side rail,
// mobile drawer) hides these for them. Matches investor-app.
export const GUEST_HIDDEN_NAV_ROUTES: readonly string[] = [routes.WALLET, routes.PORTFOLIO]

export const APP_UTILITY_NAV: AppNavItem[] = [
  { label: 'Help & Support', to: routes.HELP, icon: 'question-circle' },
  { label: 'Settings', to: routes.SETTINGS, icon: 'cog' },
]
